import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';

import { setAppLoader } from '@/redux/common/CommonActions';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { checkXpoExport } from '../data-provider/check-xpo-export';
import type { CheckXpoExportRequestParams } from '../data-provider/check-xpo-export/api';

export interface UseCheckXpoExportOptions {
  onSuccess?: (data: string) => void;
  onError?: (error: Error) => void;
}

export const useCheckXpoExport = (options?: UseCheckXpoExportOptions) => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (params: CheckXpoExportRequestParams) => checkXpoExport(params),
    onError: (error: Error) => {
      dispatch(setAppLoader(false));
      const message = error.message || 'Failed to check the XPO carrier!';
      showNotification({
        message,
        type: NOTIFICATION_TYPES.ERROR,
      });
      options?.onError?.(error);
    },
    onMutate: () => {
      dispatch(setAppLoader(true));
    },
    onSuccess: (data) => {
      dispatch(setAppLoader(false));
      options?.onSuccess?.(data);
    },
  });
};
